export interface SceneItem {
  no: string;
  title: string;
  tag: string;
  desc: string;
  image: string;
}

export const sceneItems: SceneItem[] = [
  {
    no: '01',
    title: '转赠机票的那一刻',
    tag: '开场 · 人物底色',
    desc: '父母安排出国进修，阿珍却把机票转手送人，转身走向自己的选择。一个小动作，就把角色的叛逆与对自由的向往交代清楚，也为后续的一连串意外埋下伏笔。',
    image:
      'https://readdy.ai/api/search-image?query=Vintage%20travel%20ticket%20beside%20an%20airplane%20window%20at%20dusk%2C%20retro%201990s%20film%20still%2C%20warm%20amber%20light%2C%20grainy%20nostalgic%20texture&width=800&height=600&seq=peach-scene-01&orientation=landscape',
  },
  {
    no: '02',
    title: '门前惊变',
    tag: '转折 · 情绪高点',
    desc: '带着惊喜的心情来到男友住处，迎接她的却是感情的背叛。影片在这里完成了从轻松到失落的情绪转折，也是阿珍决定出走的直接原因。',
    image:
      'https://readdy.ai/api/search-image?query=Closed%20wooden%20door%20with%20warm%20evening%20light%20spilling%20through%2C%20muted%20melancholic%20mood%2C%20retro%20film%20still%2C%20soft%20grain&width=800&height=600&seq=peach-scene-02&orientation=landscape',
  },
  {
    no: '03',
    title: '一个人上路',
    tag: '过渡 · 都市剪影',
    desc: '收拾行装、独自离去的段落，是影片最具代表性的画面之一。九十年代香港的街道、昏黄的灯光与人物的背影，共同构成了这部作品的时代记忆。',
    image:
      'https://readdy.ai/api/search-image?query=Lone%20figure%20with%20luggage%20walking%20a%20quiet%201990s%20Hong%20Kong%20street%20at%20dusk%2C%20warm%20streetlights%2C%20cinematic%20wide%20shot%2C%20film%20grain&width=800&height=600&seq=peach-scene-03&orientation=landscape',
  },
  {
    no: '04',
    title: '旅途邂逅 David',
    tag: '相遇 · 一见钟情',
    desc: '在远行的途中，阿珍遇见了年轻作家 David。两个都在漂泊的人彼此靠近，影片的节奏也从动荡转向温柔，爱情线由此真正展开。',
    image:
      'https://readdy.ai/api/search-image?query=Two%20silhouettes%20meeting%20on%20a%20seaside%20path%20at%20golden%20hour%2C%20romantic%20cinematic%20mood%2C%20warm%20amber%20tones%2C%20soft%20film%20grain&width=800&height=600&seq=peach-scene-04&orientation=landscape',
  },
  {
    no: '05',
    title: '海边的和解与重逢',
    tag: '收束 · 成长主题',
    desc: '经历波折与短暂分离后，阿珍与 David 重新走到一起。影片用一个温暖的重逢收尾，把「自由」与「爱情」两条线索收束到女主角的心灵成长上。',
    image:
      'https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20couple%20reuniting%20on%20an%20empty%20beach%20at%20sunset%2C%20hopeful%20warm%20glow%2C%20cinematic%20film%20still%2C%20gentle%20grain&width=800&height=600&seq=peach-scene-05&orientation=landscape',
  },
];